export default __webpack_public_path__ + "img/elNKqqvO.2138fe3a.svg";